import { Pill } from '@mantine/core';

export type TagColor =
  | 'orange'
  | 'red'
  | 'gray'
  | 'purple'
  | 'yellow'
  | 'green'
  | 'violet'
  | 'blue';

interface IProps {
  text: string | number | JSX.Element;
  color: TagColor;
  icon?: React.ReactNode;
  className?: string;
}

const style = (color: TagColor) =>
  `bg-${color}-100 text-${color}-500 px-2 rounded-full`;

const STYLES: Record<TagColor, string> = {
  yellow: `bg-yellow-100 border-yellow-500 text-yellow-500 px-2 rounded-full`,
  orange: `bg-orange-100 border-orange-500 text-orange-500 px-2 rounded-full`,
  red: `bg-red-100 border-red-500 text-red-500 px-2 rounded-full`,
  green: `bg-green-100 border-green-500 text-green-500 px-2 rounded-full`,
  gray: `bg-gray-100 border-gray-500 text-gray-500 px-2 rounded-full`,
  purple: `bg-purple-100 border-purple-500 text-purple-500 px-2 rounded-full`,
  violet: `bg-[#d1d7ff] text-[#5c70d9] px-2 rounded-full`,
  blue: `bg-blue-100 border-blue-500 text-blue-500 px-2 rounded-full`,
};

export const Tag = ({ text, color, icon, className }: IProps) => {
  if (icon) {
    return (
      <Pill className={style(color)}>
        <div className="flex gap-1 items-center">
          <span>{icon}</span>
          <span>{text}</span>
        </div>
      </Pill>
    );
  }
  return (
    <div className={className}>
      <Pill className={STYLES[color]}>{text}</Pill>
    </div>
  );
};
